import { Link } from 'react-router-dom';
import { siteInfo, footerLinks } from '@/mocks/home';

const NEWSLETTER_FORM_URL = 'https://readdy.ai/api/form/d8jp54nei9loc77mi2r0';

export default function Footer() {
  return (
    <footer className="bg-secondary-900">
      {/* Main Footer */}
      <div className="px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 md:gap-12">
            {/* Brand Column */}
            <div className="sm:col-span-2 lg:col-span-1">
              <Link to="/" className="flex items-center mb-4 group">
                {/* Brand Name + Registration */}
                <div className="flex flex-col">
                  <div className="flex items-baseline gap-1.5">
                    <span className="font-heading font-extrabold text-lg leading-none tracking-tight text-background-50 whitespace-nowrap">
                      INSAN
                    </span>
                    <span className="font-heading font-extrabold text-lg leading-none tracking-tight text-primary-400 whitespace-nowrap">
                      PERWIRA
                    </span>
                  </div>
                  <span className="text-[11px] font-medium tracking-[0.15em] uppercase text-foreground-400 whitespace-nowrap">
                    {siteInfo.registrationNumber}
                  </span>
                </div>
              </Link>
              <p className="text-foreground-300 text-sm leading-relaxed mb-5 max-w-xs">
                Empowering the youth of Pulau Pinang through education, mentorship, and community outreach since day one.
              </p>

            </div>

            {/* Programs */}
            <div>
              <h4 className="font-heading font-semibold text-sm text-background-50 mb-4">
                Programs
              </h4>
              <div className="w-8 h-px bg-primary-500/50 mb-4"></div>
              <ul className="space-y-3">
                {footerLinks.programs.map((link) => (
                  <li key={link.href}>
                    <Link
                      to={link.href}
                      className="text-foreground-300 hover:text-background-50 text-sm transition-colors duration-200"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Organization */}
            <div>
              <h4 className="font-heading font-semibold text-sm text-background-50 mb-4">
                Organization
              </h4>
              <div className="w-8 h-px bg-primary-500/50 mb-4"></div>
              <ul className="space-y-3">
                {footerLinks.organization.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.href}
                      className="text-foreground-300 hover:text-background-50 text-sm transition-colors duration-200"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Newsletter */}
            <div>
              <h4 className="font-heading font-semibold text-sm text-background-50 mb-4">
                Stay Updated
              </h4>
              <div className="w-8 h-px bg-primary-500/50 mb-4"></div>
              <p className="text-foreground-300 text-sm mb-4 leading-relaxed">
                Get the latest updates on our programs and impact stories.
              </p>
              <form
                data-readdy-form=""
                method="POST"
                action={NEWSLETTER_FORM_URL}
                className="flex flex-col sm:flex-row gap-2"
              >
                <input
                  type="email"
                  name="email"
                  placeholder="Your email address"
                  required
                  className="flex-1 px-4 py-2.5 rounded-lg bg-secondary-700 border border-secondary-600 text-sm text-background-50 placeholder:text-foreground-400 focus:outline-none focus:border-primary-500 transition-colors"
                />
                <button
                  type="submit"
                  className="px-5 py-2.5 rounded-lg bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium transition-all duration-200 whitespace-nowrap"
                >
                  Subscribe
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-secondary-700/50">
        <div className="px-4 md:px-6 py-5">
          <div className="max-w-6xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-foreground-400 text-xs">
              &copy; {new Date().getFullYear()} {siteInfo.name}. All rights reserved.
            </p>
            <div className="flex items-center gap-5 text-xs text-foreground-400">
              <a href={`mailto:${siteInfo.email}`} className="hover:text-background-50 transition-colors flex items-center gap-1.5">
                <i className="ri-mail-line text-sm"></i>
                {siteInfo.email}
              </a>
              <span className="flex items-center gap-1.5">
                <i className="ri-map-pin-line text-sm"></i>
                {siteInfo.address}
              </span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}